import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
/**
 * Service para gerenciamento de cache local
 */
export class CacheService {
    // Subject para notificar quando o clearAll for chamado
    private clearAllSubject = new Subject<void>();

    // Observable público que outros serviços podem assinar
    public clearAllCache$ = this.clearAllSubject.asObservable();

    clearAll() {
        // Emite um evento para todos os assinantes
        this.clearAllSubject.next();
    }
}
